<template>
  <ProtoNavigationBar v-bind="$attrs" :theme="props.theme" image="">
    <template #title>
      <span class="font-bold">{{ props.pageTitle }}</span>
    </template>
  </ProtoNavigationBar>
</template>

<script lang="ts" setup>
const props = defineProps({
  theme: { type: String, required: true },
  pageTitle: { type: String, required: true },
});
</script>
